// extracted by mini-css-extract-plugin
export default {"label":"FormLabel_label__JNZay","fadeIn":"FormLabel_fadeIn__DvXdg"};